export enum AvatarSize {
    XL3 = 'XL3', // 128px
    XL2 = 'XL2',
    XL = 'XL',
    L = 'L',
    M = 'M',
    S = 'S',
    XS = 'XS',
}
